/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactDetailsViewModel } from './ContactDetailsViewModel';
import {
    ContactDetailsViewModelFromJSON,
    ContactDetailsViewModelFromJSONTyped,
    ContactDetailsViewModelToJSON,
} from './ContactDetailsViewModel';
import type { ContactPersonViewModel } from './ContactPersonViewModel';
import {
    ContactPersonViewModelFromJSON,
    ContactPersonViewModelFromJSONTyped,
    ContactPersonViewModelToJSON,
} from './ContactPersonViewModel';
import type { OrganisationAddressesViewModel } from './OrganisationAddressesViewModel';
import {
    OrganisationAddressesViewModelFromJSON,
    OrganisationAddressesViewModelFromJSONTyped,
    OrganisationAddressesViewModelToJSON,
} from './OrganisationAddressesViewModel';
import type { TrustPartyDetailsViewModel } from './TrustPartyDetailsViewModel';
import {
    TrustPartyDetailsViewModelFromJSON,
    TrustPartyDetailsViewModelFromJSONTyped,
    TrustPartyDetailsViewModelToJSON,
} from './TrustPartyDetailsViewModel';

/**
 * 
 * @export
 * @interface TrustDetailsViewModel
 */
export interface TrustDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof TrustDetailsViewModel
     */
    partyId: number;
    /**
     * 
     * @type {TrustPartyDetailsViewModel}
     * @memberof TrustDetailsViewModel
     */
    policyHolderDetails?: TrustPartyDetailsViewModel;
    /**
     * 
     * @type {ContactPersonViewModel}
     * @memberof TrustDetailsViewModel
     */
    contactPerson?: ContactPersonViewModel;
    /**
     * 
     * @type {ContactDetailsViewModel}
     * @memberof TrustDetailsViewModel
     */
    contactDetails?: ContactDetailsViewModel;
    /**
     * 
     * @type {OrganisationAddressesViewModel}
     * @memberof TrustDetailsViewModel
     */
    addresses?: OrganisationAddressesViewModel;
    /**
     * 
     * @type {boolean}
     * @memberof TrustDetailsViewModel
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the TrustDetailsViewModel interface.
 */
export function instanceOfTrustDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function TrustDetailsViewModelFromJSON(json: any): TrustDetailsViewModel {
    return TrustDetailsViewModelFromJSONTyped(json, false);
}

export function TrustDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrustDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': json['PartyId'],
        'policyHolderDetails': !exists(json, 'PolicyHolderDetails') ? undefined : TrustPartyDetailsViewModelFromJSON(json['PolicyHolderDetails']),
        'contactPerson': !exists(json, 'ContactPerson') ? undefined : ContactPersonViewModelFromJSON(json['ContactPerson']),
        'contactDetails': !exists(json, 'ContactDetails') ? undefined : ContactDetailsViewModelFromJSON(json['ContactDetails']),
        'addresses': !exists(json, 'Addresses') ? undefined : OrganisationAddressesViewModelFromJSON(json['Addresses']),
        'isComplete': json['IsComplete'],
    };
}

export function TrustDetailsViewModelToJSON(value?: TrustDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PolicyHolderDetails': TrustPartyDetailsViewModelToJSON(value.policyHolderDetails),
        'ContactPerson': ContactPersonViewModelToJSON(value.contactPerson),
        'ContactDetails': ContactDetailsViewModelToJSON(value.contactDetails),
        'Addresses': OrganisationAddressesViewModelToJSON(value.addresses),
        'IsComplete': value.isComplete,
    };
}

